import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upcoming-related-events',
  templateUrl: './upcoming-related-events.component.html',
  styleUrls: ['./upcoming-related-events.component.scss']
})
export class UpcomingRelatedEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
